import { useEffect, useState } from "react";

// useDebounced is the value once it has stopped changing for the given time
export function useDebounced<T>(value: T, ms: number): T {
    const [settled, setSettled] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => setSettled(value), ms);
        return () => clearTimeout(timer);
    }, [value, ms]);

    return settled;
}
